//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  export default {
  name: 'exist',
  data(){
    return{
      page_img:"error",
      page_title:"",
      page_content:"",
      tel:"",
      accountStatus:"",
    }
  },
  created: function(){
     this.tel = this.$route.params.tel;
     this.accountStatus = this.$route.params.accountStatus;
     this.changeContent();
    //初始化执行的方法

    var send_track = function(cs_obj){
      var url = document.URL;
      var query = '';
      if(url.indexOf("?")!=-1){
          query = url.substring(url.indexOf("?")+1,url.length);
      }
      var eventTime = (new Date()).valueOf();
      var eventType = 'page';
      var domain = window.location.hostname;
      console.log(domain);
      var path = window.location.pathname;
      var refer = document.referrer;
      var platform = 'web';
      var title = document.title;
      var post_obj = {
          'query': query,
          'eventTime': eventTime,
          'eventType': eventType,
          'domain': domain,
          'path': path,
          'refer': refer,
          'platform': platform,
          'title': title
      }
      if(cs_obj){
          jQuery.extend(post_obj, cs_obj);
      }
      jQuery.ajax({
          url:'https://track.xiaoshouyi.com/api/ads_pv/',
          type: 'POST',
          data: post_obj,
          //dataType: 'json',
          //headers:{'Content-Type': 'application/x-www-form-urlencoded'}
      });
    }
    var cs_o = {'cs1': 'user_id:${currentUser.id}', 'cs2': 'tenant_id:${pageTenantId}', 'cs4': 'tenant_is_paid:${currentTenant.payStatus == 1}'}
        if (jQuery.cookie('ads_agent_id')){
            cs_o['cs5'] = 'ads_agent_id:'+ jQuery.cookie('ads_agent_id');
        }
         if (jQuery.cookie('ads_keywordid')){
            cs_o['cs6'] = 'ads_keywordid:'+ jQuery.cookie('ads_keywordid');
        }
        var vds_userid = '${userId}' ? '${userId}' : ('${data.userId}'?'${data.userId}':'');
        if(vds_userid != ''){
            cs_o['cs7'] = 'ads_lead_id:' + vds_userid;
        }
    send_track(cs_o);


  },


  methods: {

    changeContent(){
      if(this.accountStatus){
             this.page_img ="error";
              this.page_title="账号已存在";
              this.page_content= this.tel + " 已经是销售易用户，您可以通过销售易APP或网站进行登录。";
      }else{
             this.page_img ="success";
              this.page_title="提交成功";
              this.page_content="<p>您已成为仁科互动公司的创建者及管理员，您的登录帐号为" + this.tel + "免费试用时间30天</p> <p>您可以通过销售易APP或者网站进行登录</p>";

      }

    },
 checSystem:function(){


    var url_ios ='XSY://';
    var url_ios_download='https://itunes.apple.com/cn/app/ingage-crm/id654720925?ls=1&mt=8';
    var url_android = "XSY://com.ingageapp.ingage";
    var url_android_download = 'http://dl.xiaoshouyi.com/apps/android';

    //通过window.navigator.userAgent来判断当前设备是IOS还是Android。


    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS){
        var loadTime = new Date();
        window.location.href = url_ios;
        setTimeout(function(){
            var outTime = new Date()
            if(outTime - loadTime > 800){
                window.location.href = url_ios_download;
            }           
        },1500)
    }

    if(isAndroid){

          var loadTime = new Date();

          window.location.href = url_android; /***打开app的协议，有安卓同事提供***/

          setTimeout(function(){
              var outTime = new Date()
              if(outTime - loadTime > 800){
                  window.location.href = url_android_download;

              }
          },1500)
      }
    }
   },



}



// WEBPACK FOOTER //
// ./src/views/exist/index.vue